const RelatoriosOperador = () =>
  import(/* webpackChunkName: "group-callcenter-relatorios-operador" */ '../_views/RelatoriosOperador')

import { permissionsRelatorioOperador } from '../../../../../utils/permissionsCallCenter'

export default [
  {
    path: 'operadores',
    meta: { requiresAuth: true, permissions: [...permissionsRelatorioOperador] },
    component: RelatoriosOperador,
    name: 'RelatorioOperadores',
  },
]
